import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['mode', 'buttonFields', 'redirectFields']

  connect () {
    this.render()
  }

  render () {
    this.buttonFieldsTarget.classList.toggle('hidden', this.mode !== 'button')
    this.redirectFieldsTarget.classList.toggle('hidden', this.mode !== 'redirect')
  }

  // Private

  get mode () {
    return this.modeTargets.find((radio) => radio.checked)?.value
  }
}
